export default {
      id: "icon_stats_red_card-usage",
      viewBox: "0 0 8 10",
      url: "/" + "images/icons.3.109.2.svg#icon_stats_red_card-usage",
      toString: function () {
        return this.url;
      }
    }